import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { env } from '~/lib/env';
import { ErrorContent } from '~/modules/errors/components/ErrorContent';

export function DigitalCampaignPerformancePage() {
  // Grab the existing search params and pass them straight through to the iframe.
  // This allows us to configure URLs (e.g. - in emails) that point to the
  // relevant data (e.g. - artist, track, etc.) we want to see in the dashboard.
  const [searchParams] = useSearchParams();

  // Memoize the iframe so that we don't get a whole bunch of funky re-rendering
  // in React.StrictMode.
  const frame = useMemo(() => {
    // Wrapping this just in case the URL is misconfigured and causes an exception.
    // Better to display an error than to show nothing on the screen.
    try {
      const url = new URL(env('VITE_WMG_EMBED_PERFORMANCE_DASHBOARD_URL'));

      searchParams.forEach((value, key) => {
        // Don't allow overriding existing search params in the env URL.
        if (!url.searchParams.has(key)) {
          url.searchParams.set(key, value);
        }
      });

      return (
        <iframe
          aria-label="digital-campaign-performance-dashboard"
          src={url.toString()}
          height="100%"
          width="100%"
          style={{
            // https://stackoverflow.com/questions/5867985/full-screen-iframe-with-a-height-of-100
            overflow: 'hidden',
            height: '100%',
            width: '100%',
            border: 'none',
          }}
        />
      );
    } catch (e) {
      console.error('Error loading dashboard', e);

      return null;
    }
  }, [searchParams]);

  return frame ? (
    <div className="m-xs h-[calc(100vh-80px)]">{frame}</div>
  ) : (
    <ErrorContent type="default" variant="inline" />
  );
}

DigitalCampaignPerformancePage.displayName = 'DigitalCampaignPerformancePage';
